export default __webpack_public_path__ + "static/media/aptean-bg.a8d0ef34.jpg";